import { PublicDevelopmentManagerDetails, PublicDevelopmentManagerDetailsMetaTags } from "../components";
import { DevelopmentManagerDetailsData } from "../models";
import { usePublicDevelopmentManagerDetailsPageTemplate } from "./usePublicDevelopmentManagerDetailsPageTemplate";

interface PublicDevelopmentManagerDetailsPageTemplateProps {
  developmentManagerDetailsData?: DevelopmentManagerDetailsData;
}

export const PublicDevelopmentManagerDetailsPageTemplate = ({
  developmentManagerDetailsData,
}: PublicDevelopmentManagerDetailsPageTemplateProps): JSX.Element => {
  const {
    dataIsLoading,
    projectsCoordinates,
    developmentManagerUuid,
    navigateBackToProject,
    showContactUsModal,
    setShowContactUsModal,
  } = usePublicDevelopmentManagerDetailsPageTemplate();
  return (
    <div>
      {!dataIsLoading && developmentManagerDetailsData && (
        <>
          <PublicDevelopmentManagerDetailsMetaTags developmentManagerDetailsData={developmentManagerDetailsData} />
          <PublicDevelopmentManagerDetails
            projectsCoordinates={projectsCoordinates}
            developmentManagerUuid={developmentManagerUuid}
            isPreview={false}
            developmentManagerDetailsData={developmentManagerDetailsData}
            navigateBackToProject={navigateBackToProject}
            showContactUsModal={showContactUsModal}
            setShowContactUsModal={setShowContactUsModal}
          />
        </>
      )}
    </div>
  );
};
